/* eslint-disable @typescript-eslint/no-explicit-any */
import { navigateToUrl } from "single-spa";
import { getUrlFromPath } from "./utils";

interface NavigateEvent {
	currentTarget: {
		href: string;
		getAttribute: Function;
	};
	preventDefault: any;
	ctrlKey: boolean;
	metaKey: boolean;
}

let lastOrchestratedNavigatedUrl: string | null = null;
const _isOpenInNewTab = (event: NavigateEvent): boolean =>
	event.ctrlKey || event.metaKey || event.currentTarget.getAttribute("target") === "_blank";
const _navigate = (obj: string | NavigateEvent, opts?: Object): void => {
	if (typeof obj !== "string" && _isOpenInNewTab(obj)) {
		return;
	}
	setLastOrchestratorNavigatedUrl();
	navigateToUrl(obj, opts);
};

const spaNavigateUrl = function (obj: string | NavigateEvent, opts?: Object): void {
	if (typeof obj !== "string" && !obj.currentTarget.href) {
		const path = obj.currentTarget.getAttribute("data-goto");

		if (!path) {
			return;
		}

		obj.currentTarget.href = getUrlFromPath(path).href;
	}

	_navigate(obj, opts);
};

const epoqNavigateToUrl = function (obj: string | NavigateEvent, opts?: Object): void {
	_navigate(obj, opts);
};

const setLastOrchestratorNavigatedUrl = (): void => {
	lastOrchestratedNavigatedUrl = window.location.pathname + window.location.search;
};

const resetLastOrchestratorNavigatedUrl = (): void => {
	lastOrchestratedNavigatedUrl = null;
};

export { spaNavigateUrl, epoqNavigateToUrl, lastOrchestratedNavigatedUrl, resetLastOrchestratorNavigatedUrl };
